import React from "react";

const Form = ({
    children
}: {
    children?: any
}) => {
    return (
        <form className="form-floating">
            {children}
        </form>
    )
}

export default Form;